import MapPageDriver from 'components/mapPageDriver';
import React from 'react';

export default function MapPage() {
  return (
    <MapPageDriver/>
  );
}